import InspectionVehiclesTag from '../../../../../pages/vip/features/inspection-vehicles-tag/index';

export default InspectionVehiclesTag;
